// For card holder panel accordion functions

window.addEventListener('load', event => {
    const loadMoreButton = document.querySelectorAll('.load-more-cards-button');
    let hasShownAll = false;

    if (loadMoreButton.length) {
        let largeHeight = 0;
        let smallHeight = 0;

        loadMoreButton.forEach((element) => {
            element.addEventListener('click', function (event) {
                hasShownAll = !hasShownAll;

                let target = event.target;
                let targetParent = target.closest('section')
                let finalHeight = (largeHeight - smallHeight) * -1;

                if (hasShownAll) {
                    element.querySelector('span').innerHTML = element.querySelector('span').dataset.lessText;
                    smallHeight = targetParent.offsetHeight;
                } else {
                    element.querySelector('span').innerHTML = element.querySelector('span').dataset.moreText;
                    document.querySelector('html').style.scrollBehavior = 'auto';
                    largeHeight = targetParent.offsetHeight;
                    finalHeight = (largeHeight - smallHeight) * -1;
                    window.scrollBy(0, finalHeight);
                    document.querySelector('html').style.scrollBehavior = 'smooth';
                }

                let cardPanel = element.closest('section');
                const hiddenCards = cardPanel.querySelectorAll('.was-hidden');
                const hiddenCardsOther = cardPanel.querySelectorAll('.was-hidden-other');
                const hiddenCardsLarge = cardPanel.querySelectorAll('.was-hidden-large');
                hiddenCards.forEach(ele => {
                    ele.classList.toggle('!hidden');
                });
                hiddenCardsOther.forEach(ele => {
                    ele.classList.toggle('hidden');
                    ele.classList.toggle('lg:hidden');
                });
                hiddenCardsLarge.forEach(ele => {
                    ele.classList.toggle('hidden');
                });

                const expandFlip = cardPanel.querySelectorAll('.flip-when-expand');
                expandFlip.forEach(ele => {
                    ele.classList.toggle('-scale-x-100');
                });
            });
        });
    }

    const packageContainer = document.getElementById("packageContainer");
    const packageSorter = document.getElementById("packageSorter");

    const sortPackages = () => {
        let packageCards = [...packageContainer.querySelectorAll(".card-house-land-package-feature")]
        const packageCount = packageCards.length;
        packageContainer.innerHTML = null;

        const sortType = packageSorter.value;
        switch(sortType) {
            case "atoz":
                packageCards = packageCards.sort((a, b) => a.getAttribute('data-title').localeCompare(b.getAttribute('data-title')));
                break;
            case "ztoa":
                packageCards = packageCards.sort((a, b) => b.getAttribute('data-title').localeCompare(a.getAttribute('data-title')));
                break;
            case "pricelow":
                packageCards = packageCards.sort((a, b) => a.getAttribute('data-price') - b.getAttribute('data-price'));
                break;
            case "pricehigh":
                packageCards = packageCards.sort((a, b) => b.getAttribute('data-price') - a.getAttribute('data-price'));
                break;
        }

        packageCards.forEach((card,index) => {
            if (!hasShownAll) {
                // reset classes
                card.classList.remove('was-hidden-large')
                card.classList.remove('hidden');

                let classes = [];

                if (index > 3) {
                    classes.push('hidden');
                    classes.push('was-hidden-large');
                }

                classes.forEach((elem) => {
                    card.classList.add(elem);
                });
            }
            card.style.order = index;
            packageContainer.appendChild( card );
        })
    }

    if(packageContainer) {
        packageSorter.addEventListener('change', sortPackages);
        sortPackages();
    }
});